// removed by extract-text-webpack-plugin
module.exports = {"statsWrapper":"statsWrapper__2LLoT","titleWrapper":"titleWrapper__3_elH","sectionTitle":"sectionTitle__c-bfo","list":"list__2Fh1E","value":"value__3XVVm","label":"label__cBCJX","wrapper":"wrapper__1xaNQ","mapContainer":"mapContainer__1kpkv","disclaimer":"disclaimer__2L-Zf","recipientDocumentWrapper":"recipientDocumentWrapper__2IlvV"};


//////////////////
// WEBPACK FOOTER
// ./routes/embedViews/profile/style.scss
// module id = cN8x
// module chunks = 0